require('../modules/es6.function.bind');
require('../modules/es6.function.name');
require('../modules/es6.function.has-instance');
module.exports = require('../modules/_core').Function;


//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/core-js/es6/function.js
// module id = KvE9
// module chunks = 2